import {fadeInCardAnimation} from "@common/components/cards/animations/fade-in-card"
import {fadeInPlaceholderAnimation} from "@common/components/cards/animations/fade-in-placeholder"

export const cardAnimations = [fadeInPlaceholderAnimation, fadeInCardAnimation]
